import classNames from "classnames";
import { useId } from "react";
import { TooltipTemplate } from "UiKit/Tooltips";
import styles from "./ButtonLinkTemplate.module.css";
import React from "react";
function ButtonLinkTemplate({ href, onClick, tooltipMessage, tooltipPosition = "top", children, role = "button", isLoading = false, isError, isActive, disable, className, classNameContent, target, rel, ...props }) {
    const id = useId();
    const onClickLink = (e) => {
        if (disable || isLoading) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (onClick) {
            e.stopPropagation();
            onClick(e);
        }
    };
    return (React.createElement("a", { id: id, href: disable || isLoading ? undefined : href, role: role, className: classNames(styles.template, className), onClick: onClickLink, "aria-disabled": isLoading || disable, "data-loading": isLoading, "data-error": isError, "data-active": isActive, target: target, rel: rel || target === "_blank" ? "noopener noreferrer" : undefined, ...props },
        React.createElement("div", { className: classNames(styles["button-content"], classNameContent) }, children),
        tooltipMessage && (React.createElement(TooltipTemplate, { id: id, position: tooltipPosition },
            React.createElement("span", null, tooltipMessage)))));
}
export default ButtonLinkTemplate;
